import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-file-button',
    imports: [],
    templateUrl: './file-button.component.html',
    styleUrl: './file-button.component.scss'
})
export class FileButtonComponent {
  @Input() public selectedFileName = '';
  @Output() public isFileDropped = new EventEmitter<boolean>();

  deleteFile(): void {
    this.selectedFileName = '';
    this.isFileDropped.emit(false);
  }

}
